import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnBriefcamCase extends SnModel {
  @Expose()
  public description: string;

  @Expose()
  public id: string;

  @Expose()
  public incidentTime: any;

  @Expose()
  public name: string;

  @Expose()
  public owner: string;

  @Expose()
  public thumbnailUrls: any;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
